import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fda_cookie_consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem(KEY)) setShow(true); }, []);
  const set = (v) => { localStorage.setItem(KEY, v); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-[60] rounded-2xl border border-border bg-white/95 p-5 shadow-2xl backdrop-blur-xl sm:inset-x-auto sm:right-6 sm:max-w-md" data-testid="cookie-banner">
      <p className="text-sm text-forest-soft">
        We use necessary cookies to run this website. With your consent we also use analytics and
        advertising cookies. Read our <Link to="/cookie-policy" className="font-semibold underline">Cookie Policy</Link>.
      </p>
      <div className="mt-4 flex gap-3">
        <button data-testid="cookie-accept" onClick={() => set("all")}
          className="rounded-full bg-forest px-4 py-2 text-xs font-bold uppercase tracking-wider text-sand">Accept all</button>
        <button data-testid="cookie-reject" onClick={() => set("necessary")}
          className="rounded-full border border-border px-4 py-2 text-xs font-bold uppercase tracking-wider text-forest">Necessary only</button>
      </div>
    </div>
  );
};
